import { theme } from 'theme'

import { SxProps } from '@mui/material'

const container: SxProps = {
  mt: 2,
}

const heading: SxProps = {
  mt: 2,
}

const item: SxProps = {
  display: 'grid',
  gridTemplateAreas: {
    xs: `"name buttons" "permissions permissions"`,
    sm: `"name permissions buttons"`,
  },
  gridTemplateColumns: {
    xs: '3fr 1fr',
    sm: '3fr 8fr 1fr',
  },
  alignItems: 'center',
  gap: 2,
  py: 1,
  px: 2,
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.gray.light,
    borderRadius: 2,
  },
}

const name: SxProps = {
  gridArea: 'name',
}

const buttons: SxProps = {
  gridArea: 'buttons',
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 1.5,
  svg: { cursor: 'pointer' },
}

const permissions = { order: { xs: 1, sm: 0 }, gridArea: 'permissions' }

const Styles = {
  container,
  buttons,
  heading,
  item,
  permissions,
  name,
}

export default Styles
